module.exports = __webpack_public_path__ + "img/img5.6b03a361.png";